<template>
	<div class="header-bar">
		<div class="header-bar--left">
			<div class="logo hidden-xs-only" @click="_setMenu(1)">
				<img :src="logo" :alt="$t('图片加载失败')" />
			</div>
			<a @click="handleChange" type="text" :class="['sider-trigger', collapsed ? 'collapsed' : '']">
				<i class="icon" :class="icon"></i>
			</a>
			<slot></slot>
			<!-- 菜单tab -->
			<el-tabs v-model.trim="activeIndex" type="card" @tab-click="tabClick">
				<el-tab-pane v-for="item in menuSort" :key="item.key" :label="$t(item.value)" :name="`${item.key}`"></el-tab-pane>
			</el-tabs>
		</div>
		<div class="header-bar--right">
			<tools-bar></tools-bar>
		</div>
	</div>
</template>

<script>
import toolsBar from './tools-bar';
import { mapMutations, mapActions } from 'vuex';

export default {
	name: 'header-bar',
	props: {
		collapsed: Boolean,
		icon: {
			type: String,
			default: 'icon-command'
		}
	},
	computed: {
		// logo
		activeIndex: {
			get() {
				return `${this.$store.state.user.menuCategory}`;
			},
			set(newVal) {
				this.setMenuIndex(+newVal);
			}
		},
		index() {
			return `${this.menuSort.length ? this.menuSort[0]['key'] : 1}`;
		},
		menuSort() {
			return this.$store.state.user.menuSort;
		},
		logo() {
			return this.$store.state.user.appInfo.logo;
		},
		userInfo() {
			return this.$store.state.user.userInfo;
		}
	},
	created() {
		this._setMenu();
	},
	methods: {
		...mapMutations({ setMenuIndex: 'SET_MENU_CATEGORY_INDEX' }),
		...mapActions(['getMenuMap']),
		handleChange() {
			this.$emit('collapsed-change', !this.collapsed);
		},
		/**
		 * 选择菜单分类
		 */
		tabClick() {
			this._setMenu(this.activeIndex);
		},
		// 设置当前菜单，将菜单信息存入sessionStorage
		_setMenu(i) {
			let lang = window.localStorage.lang ? window.localStorage.lang : 'cn';
			let outPromise = null;
			let {
				userInfo: { roleId: role_id },
				$router
			} = this;
			let currentPage = window.sessionStorage.currentPage;
			let newCurrentPage = {};
			if (i) {
				newCurrentPage.index = i;
				this.activeIndex = i;
				let promise = this.getMenuMap({
					lang,
					role_id,
					menu_category: i
				});
				outPromise = promise
					.then(res => {
						let { menu } = res;
						if (menu.length) {
							if (menu[0].children) {
								let path = menu[0]['children'][0]['path'];
								newCurrentPage.path = path;
							} else {
								let path = menu[0]['path'];
								newCurrentPage.path = path;
							}
							return new Promise(resolve => {
								resolve();
							});
						} else {
							$router.push('/404');
						}
					})
					.catch(err => {
						console.log(err);
					});
			}
			// 有session
			if (!i && currentPage) {
				let { index, path } = JSON.parse(currentPage);
				if (index) {
					newCurrentPage.index = index;
					if (index !== this.activeIndex) {
						this.activeIndex = index;
					}
					let promise = this.getMenuMap({
						lang,
						role_id,
						menu_category: index
					});
					outPromise = promise
						.then(res => {
							let { menu } = res;
							if (menu.length) {
								if (path) {
									newCurrentPage.path = path;
									return;
								} else {
									if (menu[0].children) {
										newCurrentPage.path = menu[0]['children'][0]['path'];
									} else {
										newCurrentPage.path = menu[0]['path'];
									}
								}
								return new Promise(resolve => {
									resolve();
								});
							} else {
								$router.push('/404');
							}
						})
						.catch(err => {
							console.log(err);
						});
				} else {
					newCurrentPage.index = this.activeIndex;
					let promise = this.getMenuMap({
						lang,
						role_id,
						menu_category: this.activeIndex
					});
					outPromise = promise
						.then(res => {
							let { menu } = res;
							if (menu.length) {
								if (menu[0].children) {
									let path = menu[0]['children'][0]['path'];
									newCurrentPage.path = path;
								} else {
									let path = menu[0]['path'];
									newCurrentPage.path = path;
								}
								return new Promise(resolve => {
									resolve();
								});
							} else {
								$router.push('/404');
							}
						})
						.catch(err => {
							console.log(err);
						});
				}
			} else if (!i && !currentPage) {
				newCurrentPage.index = 1;
				this.activeIndex = 1;
				// 如果是德育管理员 只有五育应用一个一级菜单, 则不能跳转首页
				if (this.userInfo.roleName == '五育并举管理员') {
					newCurrentPage.index = 7;
					this.activeIndex = 7;
				}
				// 如果是学校巡检管理员 只有安全中心  一个一级菜单, 则不能跳转首页
				if (this.userInfo.roleName == '学校巡检管理员') {
					newCurrentPage.index = 3;
					this.activeIndex = 3;
				}
				let promise = this.getMenuMap({
					lang,
					role_id,
					menu_category:
						this.userInfo.roleName == '五育并举管理员'
							? 7
							: this.userInfo.roleName == '学校巡检管理员'
								? 3
								: 1
				});
				outPromise = promise
					.then(res => {
						let { menu } = res;
						if (menu.length) {
							if (menu[0].children) {
								let path = menu[0]['children'][0]['path'];
								newCurrentPage.path = path;
							} else {
								let path = menu[0]['path'];
								newCurrentPage.path = path;
							}
							return new Promise(resolve => {
								resolve();
							});
						} else {
							$router.push('/404');
						}
					})
					.catch(err => {
						console.log(err);
					});
			}
			outPromise.then(() => {
				window.sessionStorage.currentPage = JSON.stringify(newCurrentPage);
				newCurrentPage.path && $router.push(newCurrentPage.path);
			});
		},
		/**
		 * 跳转
		 */
		linkTo() {
			this.$router.push({
				name: 'home'
			});
		}
	},
	components: {
		toolsBar
	}
};
</script>


<style lang="scss" scoped>
$size: 28px;

.header-bar {
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: 100%;
	height: 100%;
	.header-bar--left {
		display: flex;
		align-items: center;
		justify-content: center;
		.logo {
			width: 122px;
			margin-right: 20px;
			img {
				width: 122px;
			}
		}
		.sider-trigger {
			width: $size;
			height: $size;
			display: inline-block;
			text-align: center;
			color: #5c6b77;
			transition: transform 0.2s ease;
			.icon {
				vertical-align: top;
				font-size: 28px;
			}
		}
		.collapsed {
			transform: rotateZ(90deg);
			transition: transform 0.2s ease;
		}
	}
	.header-bar--right {
		display: flex;
		flex-direction: row-reverse;
	}
}
</style>
<style lang="scss">
.header-bar {
	.el-tabs__header {
		border: none !important;
		margin: 0;
	}
	.el-tabs__nav {
		margin-left: 10px;
		border: none !important;
	}
	.el-tabs__item {
		height: 61px;
		line-height: 61px;
		font-size: 14px !important;
		border: none !important;
		padding: 0 20px !important;
		margin-right: 0 !important;
		&.is-active {
			background: linear-gradient(90deg, #ff8037, #ffb154);
			color: #fff;
		}
	}
}
</style>
